import React, { Component } from 'react';

export default class view extends Component {
	render() {
		return (
			<div style={{ textAlign: 'left', padding: "0 25px", overflowWrap: 'break-word' }}>
				<h3 style={{ textAlign: 'center' }}>Manual Prior Approval Required</h3>
				<hr />
				<p>The NPI that was entered is restricted from using the Enteral Automated Systems. Please call 1 (800) 342-3005 for more information. If you wish to continue with a manual PA request: </p>
				<p>Use the Order/Prior Approval Request Form (eMedNY 361502). The Prescribing Provider must sign the form in the signature field of Section 1 except in the following circumstance: If the Prescribing Provider has written a fiscal order to be used in lieu of signing the eMedNY 361502, the Dispensing Provider must write “Appears on Order” in the prescriber’s signature field in Section 1 of the form.</p>
				<p>The pharmacy or DME provider must complete Section 2 and submit it through ePACES or send it to: eMedNY, PO 4600, Rensselaer, NY 12144-4600.</p>
				<p>Form eMedNY 361502 can be ordered by calling 1(800)343-9000.</p>
			</div>
		);

	}
}